import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=4e51e406&"
import script from "./TeamMember.vue?vue&type=script&lang=ts&"
export * from "./TeamMember.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports